import { QuestionAnswerMap } from '@care-portals/api-interfaces';

export const lichenSclerosusQuestions = [
  {
    field: 'lichenSclerosus_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'lichenSclerosus_ineligible',
    label: "We're sorry you don't qualify.",
    subLabel:
      'Based on your responses, there are concerning signs that go beyond what can be safely managed remotely. Please seek in-person medical care as soon as possible. A refund will process between 5 - 10 business days.',
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    field: 'lichenSclerosus_nonConsent',
    isLast: true,
    label: `We understand that you do not consent. Please seek in-person care and a refund will process between 5 - 10 business days`,
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'lichenSclerosus_sex',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    },
    extras: { sendToBeluga: false }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'lichenSclerosus_pregnant',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label:
      'Have you been previously diagnosed with Lichen Sclerosus by a licensed healthcare provider?',
    field: 'lichenSclerosus_previouslyDiagnosed',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    label: 'What type of clinician diagnosed you?',
    field: 'lichenSclerosus_diagnosingClinician',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Dermatologist', key: 'dermatologist' },
        { value: 'Gynecologist', key: 'gynecologist' },
        { value: 'Urologist', key: 'urologist' },
        { value: 'Colorectal surgeon', key: 'colorectalSurgeon' },
        { value: 'Primary care provider', key: 'primaryCare' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    label: 'What other type of provider made your diagnosis?',
    field: 'lichenSclerosus_diagnosingClinicianOther',
    type: 'info',
    answer: {
      type: 'text',
      name: 'lichenSclerosus_diagnosingClinicianOther'
    }
  },
  {
    label: 'Approximately what year were you diagnosed?',
    field: 'lichenSclerosus_yearDiagnosed',
    type: 'info',
    answer: { type: 'text', name: 'lichenSclerosus_yearDiagnosed' }
  },
  {
    label: 'How was the diagnosis made?',
    field: 'lichenSclerosus_howDiagnosisMade',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Physical exam only', key: 'physicalExamOnly' },
        { value: 'Biopsy only', key: 'biopsyOnly' },
        { value: 'Physical exam and biopsy', key: 'physicalExamAndBiopsy' },
        { value: 'Not sure', key: 'notSure' }
      ]
    }
  },
  {
    label: 'Are you currently experiencing symptoms of Lichen Sclerosus?',
    field: 'lichenSclerosus_currentlyExperiencingSymptoms',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'notSure' }
      ]
    }
  },
  {
    label:
      'Which symptoms are you currently experiencing? (Select all that apply)',
    field: 'lichenSclerosus_symptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'Intense itching of the vulva, penis, perineum, tailbone, or perianal skin',
          key: 'intenseItching'
        },
        {
          value:
            'Burning, stinging, or soreness of the vulva, penis, perineum, tailbone, or perianal skin',
          key: 'burningStinging'
        },
        { value: 'Pain with urination due to skin irritation', key: 'painUrination' },
        { value: 'Pain with sexual activity', key: 'painSexualActivity' },
        {
          value: 'Symptoms worsen when not using treatment',
          key: 'worsenWithoutTreatment'
        },
        { value: 'No symptoms', key: 'noSymptoms', uncheckOthers: true }
      ]
    }
  },
  {
    label:
      'Which physical exam findings describe your condition? (Select all that apply)',
    field: 'lichenSclerosus_physicalExamFindings',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'White, pale, or shiny skin patches', key: 'whitePaleShiny' },
        { value: 'Thin, fragile, or tearing skin', key: 'thinFragileTearing' },
        { value: 'Bruised or easily bruised skin', key: 'bruised' },
        { value: 'Cracks, fissures, or bleeding', key: 'cracksFissuresBleeding' },
        {
          value: 'Scarring, tightening, or changes in genital anatomy',
          key: 'scarringTightening'
        },
        { value: 'Other', key: 'other', uncheckOthers: true }
      ]
    }
  },
  {
    label: 'Tell us about your other exam finding',
    field: 'lichenSclerosus_physicalExamFindingsOther',
    type: 'info',
    answer: {
      type: 'text',
      name: 'lichenSclerosus_physicalExamFindingsOther'
    }
  },
  {
    label: 'How long have your current symptoms been present?',
    field: 'lichenSclerosus_symptomsDuration',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 1 month', key: 'lessThan1Month' },
        { value: '1–6 months', key: '1to6Months' },
        { value: 'More than 6 months', key: 'moreThan6Months' }
      ]
    }
  },
  {
    label: 'Would you describe your symptoms as:',
    field: 'lichenSclerosus_symptomsDescription',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Currently flaring', key: 'currentlyFlaring' },
        { value: 'Stable but persistent', key: 'stablePersistent' },
        { value: 'Mild/minimal', key: 'mildMinimal' }
      ]
    }
  },
  {
    label:
      'Have you ever used clobetasol or another high-potency topical steroid for your symptoms?',
    field: 'lichenSclerosus_usedHighPotencySteroid',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' },
        { value: 'Not sure', key: 'notSure' }
      ]
    }
  },
  {
    label: 'Which medication have you used?',
    field: 'lichenSclerosus_steroidMedicationUsed',
    type: 'info',
    answer: {
      type: 'text',
      name: 'lichenSclerosus_steroidMedicationUsed'
    }
  },
  {
    label: 'How often did you use this medication?',
    field: 'lichenSclerosus_steroidFrequency',
    type: 'info',
    answer: { type: 'text', name: 'lichenSclerosus_steroidFrequency' }
  },
  {
    label: 'How did your symptoms respond to treatment?',
    field: 'lichenSclerosus_symptomsResponseToTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Significant improvement', key: 'significantImprovement' },
        { value: 'Partial improvement', key: 'partialImprovement' },
        { value: 'No improvement', key: 'noImprovement' }
      ]
    }
  },
  {
    label: 'Have you ever had side effects from topical steroid use?',
    field: 'lichenSclerosus_steroidSideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        { value: 'Yes', key: 'yes' }
      ]
    }
  },
  {
    label:
      'Please tell us about your reaction and which medication caused this reaction',
    field: 'lichenSclerosus_steroidSideEffectsDetails',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'lichenSclerosus_steroidSideEffectsDetails'
    }
  },
  {
    label:
      'Are you currently using any topical medications or treatments in the affected area?',
    field: 'lichenSclerosus_currentlyUsingTopical',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'No', key: 'no' },
        { value: 'Yes', key: 'yes' }
      ]
    }
  },
  {
    label: 'What medication are you currently using in the affected area?',
    field: 'lichenSclerosus_currentTopicalMedication',
    type: 'info',
    answer: {
      type: 'text',
      name: 'lichenSclerosus_currentTopicalMedication'
    }
  },
  {
    label: 'Do you have any of the following conditions? (Select all that apply)',
    field: 'lichenSclerosus_redFlagConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'I have new or rapidly worsening symptoms recently',
          key: 'rapidlyWorsening'
        },
        {
          value:
            'I have non-healing sores, ulcers, or new lesions in the affected area',
          key: 'nonHealingSores'
        },
        {
          value: 'I have been diagnosed with vulvar, penile, or skin cancer',
          key: 'diagnosedCancer'
        },
        {
          value: 'I have an active HPV or HSV genital infection',
          key: 'activeHpvHsv'
        },
        {
          value:
            'I have genital eczema, psoriasis, or any other skin condition in the genital area',
          key: 'otherGenitalSkinCondition'
        },
        {
          value:
            'I have signs of an active infection in the area (such as pus, spreading redness, fever >100.4F)',
          key: 'activeInfectionSigns'
        },
        { value: 'None of these apply to me', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'lichenSclerosus_otherInformation',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'lichenSclerosus_otherInformation'
    }
  },
  {
    label: 'Consent (Truthfulness):',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.

I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.`,
    field: 'lichenSclerosus_truthfulnessConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    label: 'Consent (Medication Specific):',
    educationalSlide: `You are requesting treatment for lichen sclerosus, a chronic inflammatory skin condition that most commonly affects the genital and perianal areas. Lichen sclerosus can cause symptoms such as itching, irritation, pain, skin thinning, color changes, fissures, and scarring.
Clobetasol propionate 0.05% is a high-potency topical corticosteroid used as first-line therapy to reduce inflammation, relieve symptoms, improve skin integrity, and help prevent disease progression and scarring.

Potential Benefits:
- Relief of itching, burning, and discomfort
- Reduction of skin inflammation and irritation
- Improvement in skin texture and appearance
- Prevention of disease progression, scarring, and architectural changes
- Improved quality of life and sexual comfort (when applicable)

Potential Side Effects:
While clobetasol propionate can be effective, it may cause side effects. Although uncommon when used as directed, misuse or prolonged use can lead to local or systemic complications. Side effects may include, but are not limited to:

Common Side Effects:
- Skin irritation, burning, or stinging at the application site
- Dryness or redness of the treated area

Serious or Less Common Side Effects:
- Skin thinning (atrophy)
- Stretch marks (striae)
- Easy bruising or tearing of the skin
- Changes in skin color
- Secondary skin infections
- Systemic absorption leading to hormonal effects (rare, but possible with prolonged or excessive use)

Risks and Considerations:
Proper Use: Clobetasol is a high-potency steroid and must be used exactly as prescribed. Overuse or use on unintended areas may increase the risk of side effects.

Skin Atrophy: Prolonged or inappropriate use may cause thinning of the skin, particularly in sensitive genital areas.

Infection Risk: Steroid use may mask or worsen underlying infections. Notify your provider if symptoms worsen, new pain develops, or discharge or sores appear.

Chronic Condition: Lichen sclerosus is a chronic condition that often requires long-term management. Even when symptoms improve, maintenance therapy and periodic monitoring may be necessary.

Cancer Risk: Long-standing, untreated lichen sclerosus carries a small increased risk of vulvar or genital skin cancer. Adherence to treatment and follow-up is important to reduce this risk.

Monitoring and Follow-up:
You will require follow-up visits to assess symptom improvement, skin response, and proper medication use. If symptoms do not improve, worsen, or recur frequently, additional evaluation or referral for in-person care may be recommended. You should report any new pain, skin breakdown, bleeding, or non-healing lesions promptly.

Consent:
I acknowledge that I have been informed about lichen sclerosus, the purpose of treatment with clobetasol propionate 0.05% cream, and the potential benefits, risks, and side effects. I understand that proper use and follow-up are essential for safe and effective treatment.

`,
    field: 'lichenSclerosus_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value: 'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

const _type = [...lichenSclerosusQuestions] as const;

export type LichenSclerosusFieldAnswers = Partial<
  QuestionAnswerMap<typeof _type>
>;

export default lichenSclerosusQuestions;
